import React, { useEffect, useMemo, useState } from 'react';
import clsx from 'clsx';
import { has, is } from '../../../services';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
import { useDrodownContext } from '../Dropdown';
/**
 * Dropdown Trigger Component
 * @param className {string} Additionnal CSS Classes
 * @param active {boolean} Active trigger
 * @param onClick {onClick} onClick event
 * @param label {string} Trigger label
 * @param placeholder {string} Trigger placeholder
 * @param children {React.ReactNode}
 */
const DropdownTrigger = ({ className, active, onClick, label, placeholder, value, ...others }) => {
    const [triggered, setTriggered] = useState(active || false);
    const { styled } = useTrilogyContext();
    const { displayDropdown } = useDrodownContext();
    const stringValue = useMemo(() => value === null || value === void 0 ? void 0 : value.join(','), [value]);
    const classes = hashClass(styled, clsx('dropdown-trigger', displayDropdown && is('triggered'), className));
    useEffect(() => {
        setTriggered(active || false);
    }, [active]);
    return (React.createElement("div", { role: 'button', onClick: (e) => {
            const target = e.target;
            setTriggered(!triggered);
            target.active = !triggered;
            if (onClick) {
                onClick({
                    active: target.active,
                });
            }
        }, className: classes, ...others },
        React.createElement("div", { className: hashClass(styled, clsx('field')) },
            React.createElement("div", { className: hashClass(styled, clsx('control', has('dynamic-placeholder'))) },
                React.createElement("div", { className: hashClass(styled, clsx('select', displayDropdown && 'select-show-options')) },
                    React.createElement("select", { style: { textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }, placeholder: placeholder, "aria-label": placeholder },
                        React.createElement("option", null, stringValue)),
                    React.createElement("label", { className: hashClass(styled, clsx('input-dynamic-placeholder')) }, label))))));
};
export default DropdownTrigger;
//# sourceMappingURL=DropdownTrigger.js.map